import React, { useEffect } from "react";
import DashboardTopSearch from "../../../components/DashboardTopSearch/DashboardTopSearch";
import DashbaordCourseCard from "../../../components/DashbaordCourseCard/DashbaordCourseCard";
import StudentHoursSpent from "../../../components/StudentHoursSpent/StudentHoursSpent";
import StudentDetailListForStudent from "../../../components/StudentDetailListForStudent/StudentDetailListForStudent";
import StudentPerformanceCard from "../../../components/StudentPerformanceCard/StudentPerformanceCard";
import StudentLeaderBoard from "../../../components/StudentLeaderBoard/StudentLeaderBoard";
import { useSelector, useDispatch } from "react-redux";
import Notification from "../../../components/Notification/Notification";
import { EnrollPlusButton } from "../../../components/svgs/Svgs";
import { Link } from "react-router-dom";
import { getLatestEnrolledCoursesAPI } from "../../../redux/features/dashboardCardsSlice";

export default function StudentDashboard() {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const { courses, isLoading, isError, message } = useSelector((state) => state.dashboardCards);

  // Fetch latest enrolled courses on component mount
  useEffect(() => {
    dispatch(getLatestEnrolledCoursesAPI());
  }, [dispatch]);

  // Define card colors and icons for dynamic courses
  const cardConfigs = [
    { dataCard: "purple", icon: getPurpleIcon() },
    { dataCard: "primary", icon: getPrimaryIcon() },
    { dataCard: "green", icon: getGreenIcon() },
    { dataCard: "yellow", icon: getYellowIcon() }
  ];

  // Helper functions to get icons
  function getPurpleIcon() {
    return (
      <svg width="38" height="39" viewBox="0 0 38 39" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="5.98682" y="6.65991" width="25.9542" height="25.9542" rx="7.07842" fill="#EDEDFB" />
        <path d="M5.98682 13.7383C5.98682 9.82903 9.15593 6.65991 13.0652 6.65991H24.8626C28.7719 6.65991 31.941 9.82903 31.941 13.7383V14.9181H5.98682V13.7383Z" fill="#353297" />
        <path d="M15.4245 19.6371C15.4245 19.6371 11.8853 21.9059 11.8853 22.3596C11.8853 22.8134 15.4245 25.5358 15.4245 25.5358" stroke="#353297" strokeWidth="1.17974" strokeLinecap="round" />
        <path d="M22.5028 19.6371C22.5028 19.6371 26.042 21.9059 26.042 22.3596C26.042 22.8134 22.5028 25.5358 22.5028 25.5358" stroke="#353297" strokeWidth="1.17974" strokeLinecap="round" />
      </svg>
    );
  }

  function getPrimaryIcon() {
    return (
      <svg width="39" height="39" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M21.4284 9.48243C21.5315 9.2173 21.5881 8.92891 21.5881 8.62731C21.5881 7.32421 20.5317 6.26784 19.2286 6.26784C17.9255 6.26784 16.8691 7.32421 16.8691 8.62731C16.8691 8.92905 16.9258 9.21756 17.029 9.48279L9.96432 16.1319C9.58125 15.8633 9.11468 15.7057 8.61129 15.7057C7.30819 15.7057 6.25182 16.762 6.25182 18.0651C6.25182 19.3682 7.30819 20.4246 8.61129 20.4246C9.91439 20.4246 10.9708 19.3682 10.9708 18.0651C10.9708 17.9232 10.9582 17.7842 10.9342 17.6492L18.242 10.7712C18.5422 10.9096 18.8764 10.9868 19.2286 10.9868C19.581 10.9868 19.9153 10.9095 20.2156 10.7711L26.655 16.8317C26.4345 17.1906 26.3073 17.613 26.3073 18.0651C26.3073 19.3682 27.3637 20.4246 28.6668 20.4246C29.9699 20.4246 31.0263 19.3682 31.0263 18.0651C31.0263 16.762 29.9699 15.7057 28.6668 15.7057C28.4752 15.7057 28.2889 15.7285 28.1106 15.7716L21.4284 9.48243Z" fill="#F05203" />
        <path d="M16.2799 27.5032C12.9831 23.2973 13.7629 21.1148 19.2292 17.4754C25.1707 21.5125 25.1357 23.6899 22.1786 27.5032L16.232 27.4419" stroke="#FFD5BE" strokeWidth="1.17974" strokeLinecap="round" />
        <path d="M15.6899 27.5032H22.7684V31.0424C22.7684 31.6939 22.2402 32.2221 21.5886 32.2221H16.8697C16.2181 32.2221 15.6899 31.6939 15.6899 31.0424V27.5032Z" fill="#F05203" />
      </svg>
    );
  }

  function getGreenIcon() {
    return (
      <svg width="39" height="39" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="6.57129" y="6.26779" width="25.9542" height="25.9542" rx="7.07842" fill="#B4D6A4" />
        <path d="M12.4697 21.0145C14.5429 18.9413 16.5988 16.8855 17.7785 15.7057C18.9583 14.526 20.138 18.6551 21.3177 18.6551C22.4975 18.6551 26.0367 13.3463 26.0367 13.3463" stroke="#82BD00" strokeWidth="1.7696" strokeLinecap="round" />
        <path d="M28.3384 23.1487C27.9852 22.0618 26.4475 22.0618 26.0944 23.1487L25.3311 25.498H22.8608C21.718 25.498 21.2428 26.9604 22.1674 27.6322L24.1659 29.0841L23.4025 31.4334C23.0494 32.5203 24.2934 33.4242 25.2179 32.7524L27.2164 31.3005L29.2148 32.7524C30.1394 33.4242 31.3834 32.5203 31.0303 31.4334L30.2669 29.0841L32.2654 27.6322C33.1899 26.9604 32.7148 25.498 31.5719 25.498L29.1017 25.498L28.3384 23.1487Z" fill="#82BD00" stroke="white" strokeWidth="1.17974" />
      </svg>
    );
  }

  function getYellowIcon() {
    return (
      <svg width="38" height="39" viewBox="0 0 38 39" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="6.07031" y="6.26779" width="25.9542" height="25.9542" rx="7.07842" fill="#F0C20C" />
        <path d="M11.9697 21.0145C14.0429 18.9413 16.0988 16.8855 17.2785 15.7057C18.4583 14.526 19.638 18.6551 20.8177 18.6551C21.9975 18.6551 25.5367 13.3463 25.5367 13.3463" stroke="#FDF6DB" strokeWidth="1.7696" strokeLinecap="round" />
        <path d="M27.8379 23.1487C27.4847 22.0618 25.9471 22.0618 25.5939 23.1487L24.8306 25.498H22.3603C21.2175 25.498 20.7423 26.9604 21.6669 27.6322L23.6654 29.0841L22.902 31.4334C22.5489 32.5203 23.7929 33.4242 24.7175 32.7524L26.7159 31.3005L28.7143 32.7524C29.6389 33.4242 30.8829 32.5203 30.5298 31.4334L29.7664 29.0841L31.7649 27.6322C32.6895 26.9604 32.2143 25.498 31.0714 25.498L28.6012 25.498L27.8379 23.1487Z" fill="#F0C20C" stroke="white" strokeWidth="1.17974" />
      </svg>
    );
  }

  // Process courses data for display
  const dashboardCardData = courses.map((course, index) => ({
    ...cardConfigs[index % cardConfigs.length], // Cycle through card configs
    title: course.courseName,
    watch: course.documentCount.toString(), // Number of documents/sources
    assignment: course.totalNotebooks.toString(), // Number of notebooks created
    student: course.totalStudents.toString(), // Number of students enrolled
    courseId: course.courseId,
    courseSubtitle: course.courseSubtitle,
    category: course.category,
    subcategory: course.subcategory
  }));

  return (
    <>
      <div className="topbar mb-20 mb-lg-36">
        <div className="d-flex align-items-center justify-content-between">
          <div>
            <h3 className="ad-heading-04 fw-bold mb-8">
              Hello {auth?.full_name} <span className="ad-heading-02">👋</span>
            </h3>
            <p className="text-gray-01 text-base fw-semibold mb-0">
              Let's learn something new today!
            </p>
          </div>
          <div className="search-wrapper d-none d-lg-flex align-items-center gap-3">
            <DashboardTopSearch />
            <Notification />
          </div>
        </div>
      </div>
      <div className="row gy-3 gy-sm-4 mb-30">
        {isLoading ? (
          <div className="col-12 d-flex justify-content-center align-items-center">
            <div className="dottedLoading theme-color"></div>
          </div>
        ) : isError ? (
          <div className="col-12 d-flex justify-content-center align-items-center">
            <div className="alert alert-danger text-center">
              <h5>Error Loading Courses</h5>
              <p className="mb-0">{message || 'Failed to load your enrolled courses. Please try again.'}</p>
            </div>
          </div>
        ) : dashboardCardData?.length > 0 ? (
          <>
            {dashboardCardData.map((items, index) => (
              <div className="col-12 col-md-6 col-lg-4 col-xl-3" key={items.courseId || index}>
                <DashbaordCourseCard
                  dataCard={items?.dataCard}
                  icon={items?.icon}
                  title={items?.title}
                  courseDetail={{
                    watch: items?.watch,
                    assignment: items?.assignment,
                    student: items?.student,
                  }}
                />
              </div>
            ))}

            {/* agar cards 4 se kam hain to extra div render karo */}
            {dashboardCardData.length < 4 && (
              <div className="col-12 col-md-6 col-lg-4 col-xl-3 d-flex justify-content-center align-items-center">
                <div className="no-dashboard-card p-16 text-center d-flex justify-content-center align-items-center flex-column">
                  <Link to={"/student-courses"}>
                    <EnrollPlusButton />
                    <p className="ah-text-sm fw-semibold text-black mb-0 mt-12">
                      Enroll in New Course
                    </p>
                  </Link>
                </div>
              </div>
            )}
          </>
        ) : (
          <div className="col-12">
            <div className="no-dashboard-card p-16 d-flex justify-content-center align-items-center flex-column">
              <h3 className="ah-heading-04 text-black mb-8 fw-bold">
                You haven't enrolled in any courses yet.
              </h3>
              <p className="ah-text-base mb-0 text-black text-opacity-50 fw-semibold">
                It looks like you haven't enrolled in any courses yet. Please enroll in a course from courses tab that interests you!
              </p>
              <Link to={"/student-courses"} className="btn btn-primary mt-3">
                Browse Courses
              </Link>
            </div>
          </div>
        )}
      </div>

      <div className="row gy-3 gy-md-4 gy-lg-5">
        <div className="col-12 col-xl-8">
          <div className="row gy-3 gy-md-4 gy-lg-5">
            <div className="col-12 col-md-7">
              <h3 className="ah-heading-05 fw-bold mb-20">Learning Progress</h3>
              <div className="card-default-style">
                <StudentHoursSpent />
              </div>
            </div>
            <div className="col-12 col-md-5 d-flex flex-column">
              <h3 className="ah-heading-05 fw-bold mb-20">Performance</h3>
              <StudentPerformanceCard />
            </div>
          </div>
          {/* <h3 className="ah-heading-05 fw-bold mb-20">Leader Board</h3>
          <StudentLeaderBoard /> */}
        </div>
        <div className="col-12 col-xl-4">
          <h3 className="ah-heading-05 fw-bold mb-20">Continue Learning</h3>
          <StudentDetailListForStudent />
        </div>
      </div>
    </>
  );
}
